import { render, staticRenderFns } from "./Tc.vue?vue&type=template&id=100c832a&scoped=true"
import script from "./Tc.vue?vue&type=script&lang=js"
export * from "./Tc.vue?vue&type=script&lang=js"
import style0 from "./Tc.vue?vue&type=style&index=0&id=100c832a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c832a",
  null
  
)

export default component.exports